import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { injectIntl } from 'react-intl';
import Input from '@ontruck/ontruck-react-components/lib/Input';
import style from './style.module.scss';

class UsersSearch extends Component {
  constructor(props) {
    super(props);

    this.handleChange = this.handleChange.bind(this);

    this.state = {
      searchText: '',
    };
  }

  handleChange(value) {
    this.props.onSearch(value);
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.reset && nextProps.reset !== this.props.reset) {
      this.setState({ searchText: '' });
    }
  }

  render() {
    const { intl } = this.props;
    const t = intl.messages.components.UsersSearch;
    return (
      <Input
        className={style.searchInput}
        value={this.state.searchText}
        label={t.search_label}
        onChange={(searchText) => this.setState({ searchText }, this.handleChange(searchText))}
      />
    );
  }
}

UsersSearch.propTypes = {
  onSearch: PropTypes.func,
  reset: PropTypes.bool.isRequired,
  intl: PropTypes.object.isRequired,
};

export default injectIntl(UsersSearch);
